import { render, staticRenderFns } from "./SoftwareDevelopment.vue?vue&type=template&id=5db789ce&scoped=true&"
var script = {}
import style0 from "./SoftwareDevelopment.vue?vue&type=style&index=0&id=5db789ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db789ce",
  null
  
)

export default component.exports